import api from "./http";

export async function getAllCards() {
    const response = await api.get("/cards/all");
    return response.data;
}

export async function getCardsByIds(cardIds) {
    const response = await api.post("/api/cards/ids", {card_ids: cardIds});
    return response.data;
}

export async function getCardsWithFilters(params) {
    const response = await api.get("/cards/filter", {params: params});
    return response.data;
}

export async function getVlCards() {
    const response = await api.get("/cards/value")
    return response.data
}

export async function getVlCardsByFilter(params) {
    const response = await api.get("/cards/filter/value", {params: params})
    return response.data
}

export async function getUniverses() {
    const response = await api.get("/cards/universes")
    return response.data
}

export async function getRares() {
    const response = await api.get("/cards/rares")
    return response.data
}

export async function getCard() {
    const response = await api.post("/api/card/get");
    return response.data;
}

export async function getWeights() {
    const response = await api.get("/api/weights");
    return response.data;
}